'use client';

import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { TabPageComponent } from '@/entities/tab/model/tab.types';
import { TabContext } from '@/entities/tab/model/tab.types';
import { TabToolbar } from '@/widgets/tab/tab-toolbar';
import { TabAwarePageWrapper } from '@/shared/ui/overlay/Modal';
import { OrderDashboardWidget } from '@/widgets/dashboard';
import { MobilePageHeader } from '@/shared/ui/mobile/MobilePageHeader';

export const HomePage: TabPageComponent = (props: TabContext) => {
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <TabAwarePageWrapper>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <TabToolbar tabId={props.tabId || ''} />
        {isMobile && <MobilePageHeader title="홈" />}
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            p: 3,
            pb: isMobile ? 0 : 3,
          }}
        >
          {!isMobile && (
            <Typography variant="h4" sx={{ marginBottom: '24px', fontWeight: 600 }}>
              홈
            </Typography>
          )}
          <OrderDashboardWidget tabId={props.tabId} tabParams={props.params} />
        </Box>
      </Box>
    </TabAwarePageWrapper>
  );
};

export default HomePage;
